export default "__VITE_ASSET__555966ea__"